/* Article page: builds the table of contents from the rendered body, keeps it
   in sync with scroll position, and wires the copy-link share button.

   The article HTML comes from the Shopify admin, so its headings have no ids.
   They are assigned here from a slug of the heading text, de-duplicated. */
(function () {
  function slug(text, used) {
    var base = text.toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60) || 'section';
    var id = base, n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    return id;
  }

  function init(root) {
    var body = root.querySelector('[data-article-body]');
    var toc = root.querySelector('[data-toc]');
    if (!body || !toc) return;

    var headings = [].slice.call(body.querySelectorAll('h2, h3'))
      .filter(function (h) { return (h.textContent || '').trim().length > 1; });

    if (headings.length < 2) { toc.style.display = 'none'; return; }

    var used = {};
    var list = document.createElement('ul');

    headings.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      h.style.scrollMarginTop = '6rem';
      var li = document.createElement('li');
      li.className = 'lvl-' + (h.tagName === 'H3' ? '3' : '2');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    var mount = toc.querySelector('[data-toc-list]') || toc;
    mount.appendChild(list);

    var links = [].slice.call(list.querySelectorAll('a'));

    // Highlight the heading nearest the top of the viewport.
    var ticking = false;
    function sync() {
      ticking = false;
      var best = 0;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top - 120 <= 0) best = i;
      }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === best); });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(sync); }
    }, { passive: true });
    sync();

    // Copy link
    var copy = root.querySelector('[data-share-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var url = window.location.href;
        var done = function () {
          copy.setAttribute('aria-label', 'Link copied');
          copy.classList.add('is-copied');
          setTimeout(function () { copy.classList.remove('is-copied'); }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = url; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t); done();
        }
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-article-root]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
